var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('customer-data-table'),_c('side-drawer',[_c('template',{slot:"formDetails"},[_c('customer-form')],1)],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }